if (!customElements.get("custom-select-wrapper")) {
  customElements.define(
    "custom-select-wrapper",
    class SelectWrapper extends HTMLElement {
      constructor() {
        super();

        intersecting({
          element: this,
          callback: this.init.bind(this),
          threshold: 200,
        });

        if (Shopify.designMode) {
          setTimeout(() => {
            this.init();
          }, 200);
        }

        this.select = this.querySelector("select");
        if (this.select) {
          this.select.addEventListener(
            "change",
            this.handleSelectChange.bind(this)
          );
        }
      }

      init() {
        const style = window.getComputedStyle(this.select);
        const value = this.select.options[this.select.selectedIndex].text;

        const text = document.createElement("span");
        text.style.fontFamily = style.fontFamily;
        text.style.fontSize = style.fontSize;
        text.style.fontWeight = style.fontWeight;
        text.style.visibility = "hidden";
        text.style.position = "absolute";
        text.innerHTML = value;

        document.body.appendChild(text);
        const width = text.clientWidth;

        this.style.setProperty("--width", `${width}px`);
        text.remove();
      }

      handleSelectChange() {
        this.init();
      }
    }
  );
}

if (!customElements.get("custom-product-bundle")) {
  customElements.define(
    "custom-product-bundle",
    class ProductBundle extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          souldout: "f-price--sold-out",
          onsale: "f-price--on-sale",
          nocompare: "f-price--no-compare",
        };

        this.price = this.querySelector(".f-price");
        this.variantSize = this.querySelector("select");

        const json = this.querySelector(".product-variants");
        
        
        this.productData = json ? JSON.parse(json.textContent) : [];

        this.selectedOptions = {};
      }

      connectedCallback() {
        this.initColorOptions();
        this.initSizeOptions();
        this.updateVariant();
      }

      initSizeOptions() {
        if (this.variantSize) {
          const firstValue = this.variantSize.options[0].value;

          this.selectedOptions[this.variantSize.name] = firstValue;
          this.variantSize.addEventListener(
            "change",
            this.onSelectChange.bind(this)
          );
        }
      }

      onSelectChange(event) {
        const select = event.target;
        const option = select.options[select.selectedIndex];

        this.selectedOptions[select.name] = option.value;
        this.updateVariant();
      }

      initColorOptions() {
        const radios = this.querySelectorAll('input[type="radio"]');
        if (!radios.length) return;

        const optionName = radios[0].name;

        radios.forEach((radio) => {
          radio.addEventListener("change", () => {
            const value = radio.value;

            const variantList = this.productData.filter(
              (v) => v.option1 === value
            );
            this.updateSizeVariant(variantList);

            this.selectedOptions[optionName] = value;
            this.updateVariant();
          });

          if (radio.checked) {
            this.selectedOptions[radio.name] = radio.value;
          }
        });

        if (this.selectedOptions[optionName] == null) {
          this.selectedOptions[optionName] = radios[0].value;
        }
      }

      updateSizeVariant(variantList) {
        if (!this.variantSize) return;

        const options = this.variantSize.options;

        for (let i = 0; i < options.length; i++) {
          const optionEl = options[i];
          const variant = variantList[i];

          if (!variant) continue;

          optionEl.dataset.available = variant.available ? "true" : "false";

          if (optionEl.dataset.available == "false") {
            optionEl.disabled = true;
            optionEl.innerHTML = `${variant.option2 || variant.option1} Sold Out`;
          } else {
            optionEl.disabled = false;
            optionEl.innerHTML = `${variant.option2 || variant.option1}`;
          }
        }
      }

      updateVariant() {
        const option1 = this.selectedOptions.option1;
        const option2 = this.selectedOptions.option2;
        if (!this.productData) return;
      
        const variant = this.productData.find((v) => {
          
          if (option2) {
            return v.option1 === option1 && v.option2 === option2;
          } else {
            return v.option1 === option1;
          }
        });
      

        if (!variant) return;

        this.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: { variant },
            bubbles: true,
          })
        );

        const sizeLabel = this.querySelector(".size-label__value");
        const colorLabel = this.querySelector(".color-label__value");

        if (sizeLabel) sizeLabel.textContent = option2 || option1;
        if (colorLabel) colorLabel.textContent = option1;

        const input = this.querySelector('[name="id"]');
        if (input) input.value = variant.id;

        this.updatePriceUI(variant);
      }

      updatePriceUI(variant) {
        const compare_at_price = variant.compare_at_price || 0;
        const price = variant.price || 0;
        const available = variant.available;

        this.price.classList.remove(
          this.classes.souldout,
          this.classes.onsale,
          this.classes.nocompare
        );

        if (!available) {
          this.price.classList.add(this.classes.souldout);
        } else if (compare_at_price > price) {
          this.price.classList.add(this.classes.onsale);
        }

        const price__regular = this.querySelector(".f-price__regular");
        if (price__regular) {
          price__regular.querySelector(".f-price-item--regular").innerHTML =
            formatMoney(price, window.FoxThemeSettings.money_format);
        }

        const price__sale = this.querySelector(".f-price__sale");
        if (price__sale) {
          price__sale.querySelector(".f-price-item--regular").innerHTML =
            formatMoney(compare_at_price, window.FoxThemeSettings.money_format);

          price__sale.querySelector(".f-price-item--sale").innerHTML =
            formatMoney(price, window.FoxThemeSettings.money_format);
        }
      }
    }
  );
}

if (!customElements.get("custom-products-bundle")) {
  customElements.define(
    "custom-products-bundle",
    class ProductsBundle extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          hover: "is-hover",
          active: "is-active",
        };

        this.buttons = {
          checkout: this.querySelector('.products-bundle__button-atc.btn-checkout'),
          soldout: this.querySelector('.products-bundle__button-atc.btn-soldout')
        };

        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.button = this.querySelector("button.products-bundle__button-atc.btn-checkout");
        this.Notification = window.FoxTheme.Notification;
        this.errorWrapper = this.querySelector(".product-form__error-message");
        if (this.button)
          this.button.addEventListener("click", this.onButtonClick.bind(this));

        this.blocks = this.querySelectorAll("[data-block-id]");
        this.blocks.forEach((block) =>
          block.addEventListener("mouseenter", this.onEnterHandler.bind(this))
        );
        this.blocks.forEach((block) =>
          block.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
        );
      }

      connectedCallback() {
        this.addEventListener('variant:change', (e) => {
          const variant = e.detail.variant;
          this.updateButton(variant);
        });

        const bundles = this.querySelectorAll('custom-product-bundle');

        bundles.forEach(bundle => {
          bundle.updateVariant();
        });
      }

      onButtonClick(event) {
        event.preventDefault();

        const bundleInput = this.querySelector('[name="bundle_id"]');

        let items;

        if (bundleInput && bundleInput.value) {
          items = {
            items: [
              {
                id: bundleInput.value,
                quantity: 1,
              },
            ],
          };
        } else {
          const ids = this.querySelectorAll('[name="id"]');

          items = {
            items: [...ids].map((e) => ({
              id: e.value,
              quantity: 1,
            })),
          };
        }

        // const ids = this.querySelectorAll('[name="id"]');
        // const items = {
        //   items: [...ids]
        //     .map((e) => e.value)
        //     .map((e) => ({
        //       id: e,
        //       quantity: 1,
        //     })),
        // };

        this.button.setAttribute("disabled", "true");
        this.button.classList.add("btn--loading");

        let sectionToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionToBundle },
          })
        );

        if (this.cartDrawer) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        }

        if (this.mainCart) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.mainCart
              .getSectionsToRender()
              .map((section) => section.section),
          ];
        }

        const body = JSON.stringify({
          ...items,
          sections: sectionToBundle,
          sections_url: window.location.pathname,
        });

        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
          },
        };
        config.body = body;
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "warning",
                message: response.description,
                last: 3000,
              });

              // Dispatch event for third-party
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.description,
                  },
                })
              );

              return;
            }

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);

            // DispatchEvent for third-party
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: {
                  product: response,
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.button.classList.remove("btn--loading");
            this.button.removeAttribute("disabled");
          });
      }

      onEnterHandler(event) {
        this.classList.add(this.classes.hover);

        const target = event.target;
        const blockId = target.dataset.blockId;
        this.blocks.forEach((block) => {
          if (target.nodeName === "PRODUCT-BUNDLE") {
            if (block.nodeName === "PRODUCT-BUNDLE") {
              block.classList.add(this.classes.active);
              return;
            }
          }
          if (block.dataset.blockId === blockId) {
            block.classList.add(this.classes.active);
          }
        });
      }

      handleProductBundle() {

      }

      onLeaveHandler() {
        this.classList.remove(this.classes.hover);
        this.blocks.forEach((block) =>
          block.classList.remove(this.classes.active)
        );
      }
      
      updateButton(variant) {
        if (variant.available == true) {
          this.buttons.checkout.classList.remove('none');
          this.buttons.soldout.classList.add('none');
        } else {
          this.buttons.checkout.classList.add('none');
          this.buttons.soldout.classList.remove('none');
        }
      }
    }
  );
}
